<template>
  <el-form>
    <div class="row">
      <div class="col-xl-6 col-md-12 col-12">
        <el-form-item
          :label="L10n('search')"
          class="material-style"
        >
          <select-search-customer-po-open
            :value="rfqID"
            @on-change="handleChange"
          />
        </el-form-item>
      </div>
      <div class="col-xl-6 col-md-12 col-12 d-flex justify-content-end">
        <div class="pl-3 pt-md-0 pt-3">
          <el-form-item data-filed="true" class="material-style">
            <button :disabled="disabledCreatePoWo" type="button" class="btn btn-size-s btn-mobile-full" @click="handleCreateWO">{{L10n('create-wo')}}</button>
          </el-form-item>
        </div>
        <div class="pl-3 pt-md-0 pt-3">
          <el-form-item data-filed="true" class="material-style">
            <button :disabled="disabledCreatePoWo" type="button" class="btn btn-size-s btn-mobile-full" @click="handleCreatePO">{{L10n('create-supplier-po')}}</button>
          </el-form-item>
        </div>
        <div class="pl-3 pt-md-0 pt-3" v-if="showNew">
          <el-form-item data-filed="true" class="material-style">
            <button type="button" class="btn btn-size-s btn-mobile-full" @click="handleNew"><i class="fas fa-plus"/> {{L10n('add-new-supplier-quote')}}</button>
          </el-form-item>
        </div>
      </div>
    </div>
  </el-form>
</template>

<script>
export default {
  name: 'ToolsPanel',
  components: {
    'select-search-customer-po-open': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectSearchCustomerPoOpen')
  },
  props: {
    showNew: { type: Boolean, required: true },
    rfqID: { required: true },
    disabledCreatePoWo: { type: Boolean, required: true }
  },
  methods: {
    handleChange (id) {
      this.$emit('onChange', id)
    },
    handleNew () {
      this.$emit('onNew')
    },
    handleCreatePO () {
      this.$emit('onCreatePO')
    },
    handleCreateWO () {
      this.$emit('onCreateWO')
    }
  }
}
</script>
